import styled from "styled-components/macro"
import { mobile, tablet } from "../styles/responsive"
import { Link } from "react-router-dom"

export const Container = styled.div`
  height: 60px;
  ${mobile({ height: "50px" })}
`
export const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mobile({ padding: "10px 0px" })}
`
export const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  ${tablet({ display: "none" })}
`

export const SearchContainer = styled.div`
  border: 0.5px solid lightgray;
  border-radius: 20px;
  display: flex;
  align-items: center;
  margin-left: 25px;
  padding: 5px;
`
export const Input = styled.input`
  border: none;
  &:focus {
    outline: none;
  }
  ${mobile({ width: "50px" })}
`
export const Logo = styled.h1`
  font-weight: bold;
  ${mobile({ fontSize: "24px" })}
`

export const Center = styled.div`
  flex: 1;
  text-align: center;
  ${tablet({ textAlign: "left" })}
`
export const Right = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
  ${mobile({ flex: 1, justifyContent: "center" })}
`
export const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  color: black;
  margin-left: 20px;
  ${mobile({ fontSize: "12px", marginLeft: "10px" })}
  &:hover {
    color: #4c87ef;
  }
`
export const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`
export const ExternalLink = styled.a`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`
